// Dernier élève connecté, pour attribuer les rapports envoyés au démarrage
// suivant (garde de crash, page figée) : à ce moment-là, Sentry ne connaît
// pas encore l'utilisateur. Séparé de freezeDetector.js, chargé à part, pour
// que AuthContext n'embarque pas le détecteur dans le bundle principal.
import { safeGetItem, safeRemoveItem, safeSetItem } from '../utils/storage';

const USER_KEY = 'kaiylo:last-user-id';

export const rememberFreezeUser = (id) => (id ? safeSetItem(USER_KEY, id) : safeRemoveItem(USER_KEY));

export const getRememberedUserId = () => safeGetItem(USER_KEY);
